import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function Form() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const profileFilter = chooseProfileFilter();

    const { id } = useParams();

    const path = '/governanceroom/observatorycities/';
    const endpointBackend = config.endpoints.backend
    const paths = {
        endpointSave: endpointBackend + 'governanceroom/observatorycities/save',
        endpointGetById: endpointBackend + 'governanceroom/observatorycities/getById',
        endpointGetOneCity: endpointBackend + 'governanceroom/observatorycities/getone',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Município - Observatório",
        labelTitleEdit: "Editar Município - Observatório",
        labelTitleView: 'Visualizar Município - Observatório'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'governance_room_client_city_id',
                    type: 'select',
                    label: 'Município',
                    options: [],
                    optionsEndpoint: {
                        endpoint: endpointBackend + 'governanceroom/clientscities/getall',
                        label: 'client_city_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'portal_logo',
                    type: 'fileS3',
                    label: 'Logo (Sugestão: 100x100)',
                    uploadPath: '/clientscities/portal/',
                    extensionAccept: '.jpeg,.jpg,.png',
                    limitFileSize: 100,
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'portal_url',
                    type: 'text',
                    label: 'URL Amigável',
                    validations: {
                        required: true,
                        verifyFriendlyUrl: true
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                verifyFriendlyUrl: async (value, options, key, attributes) => {
                    if (attributes.portal_url) {
                        const verifyData = await Fetch.post(paths.endpointGetOneCity, {
                            filter: {
                                portal_url: attributes.portal_url,
                                deleted: '0'
                            }
                        })

                        if (
                            verifyData &&
                            verifyData.portal_url == attributes.portal_url &&
                            verifyData.id != id
                        ) {
                            return '^ Já existe uma entidade com essa URL.';
                        } else {
                            return '';
                        }
                    } else {
                        return '';
                    }
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
